import React from "react";
import Navlink from "./Navlink";

const ModuleCard = ({ content }) => {
  const { module, title, url, color } = content;
  return (
    <Navlink url={url} unidad>
        <p className={`c-${color} mb-0 menu-item`}>
           {module}: {title}
        </p>
    </Navlink>
  );
};

export default ModuleCard;
